"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ZERO = exports.DIGITS = exports.DECIMALS = void 0;
exports.DECIMALS = 18;
exports.DIGITS = 4;
exports.ZERO = '0';
//# sourceMappingURL=dappConstants.js.map